import { render } from "./AddBatchElevatorParts.vue?vue&type=template&id=313dcba8"
import script from "./AddBatchElevatorParts.vue?vue&type=script&lang=js"
export * from "./AddBatchElevatorParts.vue?vue&type=script&lang=js"

import "./AddBatchElevatorParts.vue?vue&type=style&index=0&id=313dcba8&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__